import { render, staticRenderFns } from "./SourceType.vue?vue&type=template&id=9dfd6404&scoped=true"
import script from "./SourceType.vue?vue&type=script&lang=js"
export * from "./SourceType.vue?vue&type=script&lang=js"
import style0 from "./SourceType.vue?vue&type=style&index=0&id=9dfd6404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfd6404",
  null
  
)

export default component.exports